/**
 * Styles
 */
import './style.scss';

/**
 * External Dependencies
 */
import React from 'react';
import { DropdownToggle, DropdownMenu } from 'reactstrap';

/**
 * Internal Dependencies
 */
import BsDropdown from '../bs-dropdown';

// Icons are served statically from public/apps (not bundled), so they only load
// when the launcher opens. Referenced by absolute root path, per www convention.
const mayarIcon = '/apps/mayar.webp';
const shopIcon = '/apps/shop.webp';
const walletIcon = '/apps/wallet.webp';
const madmaxIcon = '/apps/madmax.webp';
const mayaraccountIcon = '/apps/account.webp';
const mayarcardIcon = '/apps/mayarcard.webp';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const SHOP_URL = process.env.REACT_APP_MAYAR_SHOP_URL;
const WALLET_URL = process.env.REACT_APP_MAYAR_WALLET_URL;
const MADMAX_URL = process.env.REACT_APP_MAYAR_MADMAX_URL;
const MAYARACCOUNT_URL = process.env.REACT_APP_MAYAR_ACCOUNT_URL;
const MAYARCARD_URL = process.env.REACT_APP_MAYAR_CARD_URL;

// The Mayar app suite shown in the launcher. Only platforms that log in silently via
// auth-v2's warm IdP session carry the `?from=mayar` handoff (currently just Wallet —
// KYC is reached from its own verification entry, not this grid). Everything else is a
// plain link opened in a new tab. Tiles with no configured URL are dropped.
const APPS = [
  { key: 'mayar', name: 'Mayar', icon: mayarIcon, href: BASE_URL },
  { key: 'shop', name: 'Shop', icon: shopIcon, href: SHOP_URL },
  {
    key: 'wallet',
    name: 'Wallet',
    icon: walletIcon,
    href: WALLET_URL ? `${WALLET_URL}/?from=mayar` : ''
  },
  { key: 'madmax', name: 'MAdMAX', icon: madmaxIcon, href: MADMAX_URL },
  {
    key: 'mayaraccount',
    name: 'Account',
    icon: mayaraccountIcon,
    href: MAYARACCOUNT_URL ? `${MAYARACCOUNT_URL}/?from=mayar` : ''
  },
  {
    key: 'mayarcard',
    name: 'MayarCard',
    icon: mayarcardIcon,
    href: MAYARCARD_URL
  }
].filter(app => app.href);

// 3x3 dot grid (app-launcher glyph), built once to keep keys stable.
const DOTS = [];
[3, 10, 17].forEach(y => [3, 10, 17].forEach(x => DOTS.push({ x, y })));

const GridIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    {DOTS.map(dot => (
      <circle key={`${dot.x}-${dot.y}`} cx={dot.x} cy={dot.y} r="1.7" />
    ))}
  </svg>
);

/**
 * Mayar app launcher — a grid icon in the top nav that opens a popover of the
 * Mayar platforms the user can jump to. Native to www (reactstrap BsDropdown).
 * @returns {JSX.Element|null} Return Dropdown Element
 */
const AppLauncher = () => {
  if (!APPS.length) {
    return null;
  }

  return (
    <BsDropdown className="dib app-launcher" showTriangle>
      <DropdownToggle
        tag="button"
        type="button"
        caret={false}
        className="app-launcher-toggle"
        aria-label="Aplikasi Mayar"
      >
        <GridIcon />
      </DropdownToggle>
      <DropdownMenu right className="app-launcher-menu" tag="div">
        <p className="app-launcher-title">Apps</p>
        <div className="app-launcher-grid">
          {APPS.map(app => (
            <a key={app.key} href={app.href} target="_blank" rel="noopener noreferrer" className="app-launcher-item">
              <span className="app-launcher-icon" style={{ background: app.key === 'madmax' ? 'black' : 'none' }}>
                <img src={app.icon} alt={app.name} />
              </span>
              <span className="app-launcher-name">{app.name}</span>
            </a>
          ))}
        </div>
      </DropdownMenu>
    </BsDropdown>
  );
};

export default AppLauncher;
